export const createChipsContentText = (label: string, value: string) => `${label}: ${value}`;
